module.exports = __webpack_public_path__ + "img/mode2-5.8070e220.png";